{
  "users": {
    "pageTitle": "Użytkownicy",
    "accessDenied": "Nie masz uprawnień do tej strony.",
    "pageSubtitle": "Zarządzanie kontami użytkowników i ich uprawnieniami",
    "table": {
      "email": "Email",
      "name": "Imię i nazwisko",
      "role": "Role",
      "status": "Status",
      "createdAt": "Utworzono",
      "actions": ""
    },
    "filters": {
      "searchPlaceholder": "Szukaj po nazwie lub emailu...",
      "roleAll": "Wszystkie role",
      "roleSearchPlaceholder": "Szukaj roli...",
      "roleNoResults": "Brak wyników",
      "statusAll": "Wszyscy",
      "statusActive": "Aktywni",
      "statusInactive": "Nieaktywni",
      "count_one": "{{count}} użytkownik",
      "count_few": "{{count}} użytkowników",
      "count_many": "{{count}} użytkowników"
    },
    "status": {
      "active": "Aktywny",
      "inactive": "Nieaktywny"
    },
    "actions": {
      "addUser": "Dodaj użytkownika",
      "edit": "Edytuj",
      "deactivate": "Dezaktywuj konto",
      "cancel": "Anuluj",
      "save": "Zapisz zmiany",
      "saving": "Zapisywanie...",
      "saved": "Zapisano",
      "createUser": "Utwórz użytkownika"
    },
    "pagination": {
      "page": "Strona {{page}} z {{total}} ({{count}} wyników)",
      "prev": "Poprzednia strona",
      "next": "Następna strona",
      "goToPage": "Strona {{page}}"
    },
    "empty": {
      "title": "Brak użytkowników",
      "description": "Zmień kryteria wyszukiwania lub dodaj nowego użytkownika."
    },
    "create": {
      "title": "Nowy użytkownik",
      "close": "Zamknij",
      "fields": {
        "email": "Email",
        "emailPlaceholder": "jan.kowalski@firma.pl",
        "emailInvalid": "Podaj poprawny adres email",
        "name": "Imię i nazwisko",
        "namePlaceholder": "Jan Kowalski",
        "role": "Role",
        "rolePlaceholder": "Wybierz role...",
        "roleSearchPlaceholder": "Szukaj ról...",
        "roleNoResults": "Brak wyników",
        "password": "Hasło (min. 12 znaków, musi zawierać cyfrę lub symbol)",
        "minLength": "Hasło musi mieć co najmniej 12 znaków",
        "requiresNumberOrSymbol": "Hasło musi zawierać co najmniej jedną cyfrę lub symbol",
        "confirmPassword": "Potwierdź hasło",
        "confirmInvalid": "Hasła nie są zgodne"
      },
      "errors": {
        "emailTaken": "Adres email jest już zajęty"
      }
    },
    "edit": {
      "title": "Edytuj użytkownika",
      "close": "Zamknij",
      "fields": {
        "email": "Email (tylko do odczytu)",
        "name": "Imię i nazwisko",
        "role": "Role",
        "rolePlaceholder": "Wybierz role...",
        "roleSearchPlaceholder": "Szukaj ról...",
        "roleNoResults": "Brak wyników",
        "active": "Konto aktywne"
      },
      "overrides": {
        "title": "Nadpisania uprawnień",
        "description": "Kliknij, aby zmienić stan: Dziedzicz → Przyznaj → Odbierz",
        "inherit": "Dziedzicz",
        "grant": "Przyznaj",
        "revoke": "Odbierz",
        "sections": {
          "media_unit": "Nośniki",
          "attachment": "Załączniki",
          "supplier": "Dostawcy",
          "media_format": "Formaty",
          "map": "Mapa",
          "cost_history": "Historia kosztów",
          "admin": "Administracja"
        }
      },
      "deactivateConfirm": "Czy na pewno chcesz dezaktywować konto? Użytkownik straci dostęp.",
      "deactivateDialog": {
        "title": "Dezaktywuj konto",
        "description": "Czy na pewno chcesz dezaktywować to konto? Użytkownik straci dostęp do systemu.",
        "cancel": "Anuluj",
        "confirm": "Dezaktywuj"
      },
      "errors": {
        "partialSave": "Dane podstawowe zapisano, ale nadpisania uprawnień nie zostały zapisane. Spróbuj ponownie."
      }
    },
    "setPassword": {
      "action": "Zmień hasło",
      "title": "Zmień hasło użytkownika",
      "fields": {
        "password": "Nowe hasło (min. 12 znaków, musi zawierać cyfrę lub symbol)",
        "confirmPassword": "Potwierdź nowe hasło",
        "confirmInvalid": "Hasła nie są zgodne",
        "minLength": "Hasło musi mieć co najmniej 12 znaków",
        "requiresNumberOrSymbol": "Hasło musi zawierać co najmniej jedną cyfrę lub symbol"
      },
      "saving": "Zapisywanie...",
      "success": "Hasło zostało zmienione",
      "sessionNote": "Zmiana hasła wyloguje użytkownika z pozostałych sesji."
    }
  },
  "formatGroups": {
    "pageTitle": "Słowniki systemowe - Grupy formatów",
    "pageSubtitle": "Zarządzanie grupami formatów nośników reklamowych",
    "actions": {
      "addGroup": "Dodaj grupę",
      "edit": "Edytuj",
      "deactivate": "Dezaktywuj"
    },
    "filters": {
      "statusAll": "Wszystkie",
      "statusActive": "Aktywne",
      "statusInactive": "Nieaktywne"
    },
    "table": {
      "code": "Kod",
      "name": "Nazwa",
      "sortOrder": "Kolejność",
      "formatCount": "Formaty",
      "status": "Status",
      "actions": ""
    },
    "status": {
      "active": "Aktywna",
      "inactive": "Nieaktywna"
    },
    "empty": {
      "title": "Brak grup formatów",
      "description": "Dodaj pierwszą grupę formatów."
    },
    "create": {
      "title": "Dodaj grupę formatów",
      "close": "Zamknij"
    },
    "edit": {
      "title": "Edytuj grupę formatów",
      "close": "Zamknij"
    },
    "fields": {
      "code": "Kod",
      "codePlaceholder": "np. large_format",
      "codeHint": "Unikalny identyfikator techniczny. Użyj podkreślników zamiast spacji. Nie można zmienić po utworzeniu.",
      "name": "Nazwa",
      "namePlaceholder": "np. Wielki Format",
      "sortOrder": "Kolejność sortowania",
      "isActive": "Grupa aktywna"
    },
    "errors": {
      "codeTaken": "Ten kod jest już zajęty"
    },
    "deactivate": {
      "title": "Dezaktywacja grupy {{name}}",
      "rolesHeader": "Role, które stracą dostęp do tej grupy",
      "formatsWarning_one": "{{count}} aktywny format straci przypisanie do grupy",
      "formatsWarning_few": "{{count}} aktywne formaty stracą przypisanie do grupy",
      "formatsWarning_many": "{{count}} aktywnych formatów straci przypisanie do grupy",
      "noEffects": "Dezaktywacja nie wpłynie na dostęp żadnej roli.",
      "confirm": "Potwierdź dezaktywację",
      "cancel": "Anuluj"
    },
    "save": "Zapisz",
    "saving": "Zapisywanie...",
    "saved": "Zapisano",
    "cancel": "Anuluj"
  },
  "permissionMatrix": {
    "header": {
      "title": "Uprawnienia",
      "infoLabel": "O tym ekranie",
      "infoText": "Macierz uprawnień dla 22 ról systemowych Grupy RW.",
      "historyButton": "Historia zmian",
      "newRoleButton": "Nowa rola"
    },
    "accessDenied": "Nie masz uprawnień do tej strony.",
    "loading": "Ładowanie...",
    "saveBar": {
      "discard": "Odrzuć zmiany",
      "save": "Zapisz zmiany ({{count}})",
      "saved": "Zapisano zmiany",
      "bundleIncomplete": "Te uprawnienia muszą być nadane lub odebrane razem.",
      "bundleIncompleteDetailed": "{{grantedNames}} wymaga też uprawnienia {{missingNames}} z tym samym zakresem."
    },
    "sidebar": {
      "searchPlaceholder": "Szukaj roli...",
      "searchAriaLabel": "Szukaj roli",
      "emptyState": "Brak ról pasujących do wyszukiwania"
    },
    "roleGroups": {
      "system": "Administratorzy systemu",
      "deptAdmins": "Administratorzy działów",
      "managers": "Kierownicy działów",
      "staff": "Pracownicy działów"
    },
    "sections": {
      "media_unit": "Nośniki",
      "reservation": "Rezerwacje",
      "attachment": "Załączniki",
      "supplier": "Dostawcy",
      "map": "Mapa",
      "cost": "Koszty",
      "offer": "Oferty",
      "admin": "Administracja",
      "client": "Klienci",
      "tag": "Tagi",
      "media_format": "Formaty",
      "cost_history": "Historia kosztów",
      "import": "Import",
      "bulk_edit": "Edycja masowa",
      "admin_boundary": "Granice administracyjne"
    },
    "permissionInfoLabel": "Co oznacza to uprawnienie",
    "permissions": {
      "media_unit": {
        "view": {
          "name": "Podgląd nośników",
          "desc": "Przeglądanie katalogu nośników (bez pól wrażliwych)."
        },
        "update_availability": {
          "name": "Aktualizacja dostępności nośnika",
          "desc": "Zmiana dostępności i statusu nośnika."
        },
        "block_availability": {
          "name": "Blokowanie dostępności nośnika",
          "desc": "Tworzenie okien dostępności (Wolne/Niedostępne) dla nośnika."
        },
        "create": {
          "name": "Dodawanie nośników",
          "desc": "Dodawanie nowych nośników do katalogu."
        },
        "edit": {
          "name": "Edycja nośników",
          "desc": "Edycja istniejących nośników."
        },
        "delete": {
          "name": "Usuwanie nośników",
          "desc": "Usuwanie nośników z katalogu."
        }
      },
      "media_units": {
        "import": {
          "name": "Import nośników (starsze)",
          "desc": "Wgrywanie i import nośników z szablonu XLSX. Starszy kod utrzymywany obok kanonicznego uprawnienia „import” dla zgodności wstecznej."
        }
      },
      "reservation": {
        "manage": {
          "name": "Zarządzanie rezerwacjami",
          "desc": "Tworzenie i modyfikowanie rezerwacji oraz statusów nośników."
        },
        "manage_waitlist": {
          "name": "Zarządzanie kolejką oczekujących",
          "desc": "Usuwanie innych użytkowników z kolejki oczekujących."
        },
        "force_release": {
          "name": "Wymuszanie zwolnienia rezerwacji",
          "desc": "Wymuszenie anulowania cudzej rezerwacji i podgląd wszystkich rezerwacji."
        },
        "view": {
          "name": "Podgląd rezerwacji",
          "desc": "Przeglądanie rezerwacji i ich statusów."
        },
        "create": {
          "name": "Tworzenie rezerwacji",
          "desc": "Tworzenie rezerwacji dla okien dostępności."
        },
        "cancel": {
          "name": "Anulowanie rezerwacji",
          "desc": "Anulowanie własnych rezerwacji."
        },
        "upgrade_hard": {
          "name": "Zmiana na rezerwację potwierdzoną",
          "desc": "Zmiana rezerwacji wstępnej na potwierdzoną."
        },
        "close_sale": {
          "name": "Zamknięcie sprzedaży rezerwacji",
          "desc": "Oznaczenie rezerwacji jako sprzedanej."
        },
        "extend": {
          "name": "Przedłużanie rezerwacji",
          "desc": "Przedłużanie czasu ważności lub widoczności rezerwacji."
        },
        "list": {
          "name": "Lista rezerwacji",
          "desc": "Podgląd listy rezerwacji i zdarzeń nośnika."
        },
        "update_dates": {
          "name": "Edycja dat rezerwacji",
          "desc": "Edycja dat początku i końca rezerwacji."
        }
      },
      "attachment": {
        "manage": {
          "name": "Zarządzanie załącznikami",
          "desc": "Dodawanie, edycja i usuwanie załączników nośnika."
        },
        "view": {
          "name": "Podgląd załączników",
          "desc": "Przeglądanie załączników nośnika."
        }
      },
      "supplier": {
        "manage": {
          "name": "Zarządzanie dostawcami",
          "desc": "Wprowadzanie i edycja danych dostawców oraz kontaktów."
        },
        "view": {
          "name": "Podgląd dostawców",
          "desc": "Przeglądanie dostawców."
        }
      },
      "map": {
        "view": {
          "name": "Podgląd mapy",
          "desc": "Dostęp do interaktywnego widoku mapy."
        }
      },
      "cost": {
        "view": {
          "name": "Podgląd kosztów",
          "desc": "Podgląd kosztów nośnika (ekspozycja, produkcja, montaż, demontaż i koszty dodatkowe). Nie obejmuje czynszu — wymaga osobnego uprawnienia \"Podgląd czynszu\"."
        },
        "view_rent": {
          "name": "Podgląd czynszu",
          "desc": "Podgląd czynszu nośnika. Samo to uprawnienie nic nie daje — wymaga też \"Podgląd kosztów\"."
        },
        "view_history": {
          "name": "Podgląd historii kosztów",
          "desc": "Przeglądanie historii zmian kosztów nośnika."
        }
      },
      "cost_history": {
        "view": {
          "name": "Podgląd historii kosztów (starsze)",
          "desc": "Podgląd historii kosztów nośnika. Starszy kod utrzymywany obok kanonicznego uprawnienia „cost.view_history” dla zgodności wstecznej."
        }
      },
      "offer": {
        "prepare": {
          "name": "Przygotowywanie ofert",
          "desc": "Tworzenie i przygotowywanie ofert."
        },
        "publish": {
          "name": "Publikowanie ofert",
          "desc": "Publikowanie wersji ofert."
        },
        "delete": {
          "name": "Usuwanie ofert",
          "desc": "Usuwanie ofert."
        },
        "view_all": {
          "name": "Podgląd wszystkich ofert",
          "desc": "Podgląd wszystkich ofert danego działu."
        },
        "approve_any": {
          "name": "Zatwierdzanie dowolnej oferty",
          "desc": "Zatwierdzanie oferty innego użytkownika w jego imieniu."
        },
        "create": {
          "name": "Tworzenie ofert",
          "desc": "Tworzenie draftów ofert."
        },
        "view": {
          "name": "Podgląd ofert",
          "desc": "Podgląd draftów ofert."
        },
        "update": {
          "name": "Edycja ofert",
          "desc": "Edycja draftów ofert."
        },
        "manage-any": {
          "name": "Zarządzanie dowolną ofertą",
          "desc": "Zarządzanie ofertami utworzonymi przez innych użytkowników."
        },
        "set_status_any": {
          "name": "Zmiana statusu dowolnej oferty",
          "desc": "Zmiana statusu dowolnej oferty."
        }
      },
      "admin": {
        "manage_users": {
          "name": "Zarządzanie użytkownikami",
          "desc": "Tworzenie i zarządzanie kontami użytkowników oraz nadpisaniami uprawnień."
        },
        "manage_roles": {
          "name": "Zarządzanie rolami",
          "desc": "Tworzenie i zarządzanie rolami użytkowników."
        },
        "manage_permissions": {
          "name": "Zarządzanie uprawnieniami",
          "desc": "Tworzenie i zarządzanie definicjami uprawnień."
        }
      },
      "client": {
        "view": {
          "name": "Podgląd klientów",
          "desc": "Przeglądanie klientów."
        },
        "create": {
          "name": "Dodawanie klientów",
          "desc": "Dodawanie nowych klientów."
        },
        "update": {
          "name": "Edycja klientów",
          "desc": "Edycja danych klientów."
        },
        "delete": {
          "name": "Usuwanie klientów",
          "desc": "Usuwanie klientów."
        }
      },
      "tag": {
        "view": {
          "name": "Podgląd tagów",
          "desc": "Przeglądanie tagów."
        },
        "create": {
          "name": "Dodawanie tagów",
          "desc": "Tworzenie nowych tagów."
        },
        "update": {
          "name": "Edycja tagów",
          "desc": "Edycja tagów."
        },
        "delete": {
          "name": "Usuwanie tagów",
          "desc": "Usuwanie tagów."
        }
      },
      "media_format": {
        "view": {
          "name": "Podgląd formatów",
          "desc": "Przeglądanie formatów nośników."
        },
        "create": {
          "name": "Dodawanie formatów",
          "desc": "Tworzenie nowych formatów nośników."
        },
        "update": {
          "name": "Edycja formatów",
          "desc": "Edycja formatów nośników."
        }
      },
      "import": {
        "name": "Import nośników",
        "desc": "Import nośników z pliku XLSX."
      },
      "bulk_edit": {
        "name": "Edycja masowa",
        "desc": "Masowa edycja wielu nośników jednocześnie."
      },
      "admin_boundary": {
        "import": {
          "name": "Import granic administracyjnych",
          "desc": "Ręczne uruchomienie importu danych referencyjnych granic administracyjnych."
        }
      }
    },
    "roleHeader": {
      "renameSaveAriaLabel": "Zapisz nazwę",
      "renameCancelAriaLabel": "Anuluj",
      "renameButtonAriaLabel": "Zmień nazwę roli",
      "immutableBadge": "Zablokowane",
      "immutableInfoLabel": "Dlaczego zablokowane",
      "immutableInfoText": "Rola „Power User\" ma pełny dostęp do systemu i nie można jej zmienić, zmienić nazwy ani dezaktywować.",
      "inactiveTag": "nieaktywna",
      "deactivateButton": "Dezaktywuj rolę",
      "activateButton": "Aktywuj rolę"
    },
    "grant": {
      "noAccess": "Brak dostępu",
      "grantButton": "Nadaj",
      "addScope": "Dodaj zakres",
      "addScopeExhausted": "Każda odrębna kombinacja własności i działu jest już wykorzystana przez istniejący zakres",
      "scopeCollisionHint": "Ta kombinacja własności i działu jest już wykorzystana przez inny zakres tego uprawnienia",
      "removeScopeAriaLabel": "Usuń zakres — {{name}}: {{scope}}",
      "bundleNotice": "Wymagane razem z: {{names}}.",
      "mediaType": {
        "title": "Typy nośników",
        "allOption": "Wszystkie typy nośników"
      },
      "ownership": {
        "title": "Własność nośników",
        "both": "RW + Broker",
        "rwOnly": "Tylko RW",
        "brokerOnly": "Tylko Broker"
      },
      "department": {
        "title": "Dział",
        "all": "Wszystkie działy",
        "sales": "dz. Sprzedaży",
        "planners": "dz. Planowania",
        "newProducts": "dz. Nowych Produktów"
      }
    },
    "auditPanel": {
      "title": "Historia zmian",
      "closeAriaLabel": "Zamknij",
      "loading": "Ładowanie...",
      "emptyState": "Brak zdarzeń do wyświetlenia",
      "unknownActor": "Nieznany użytkownik",
      "actions": {
        "roleCreated": "Utworzono rolę",
        "roleUpdated": "Zaktualizowano rolę",
        "roleScopesUpdated": "Zaktualizowano uprawnienia roli"
      }
    },
    "newRole": {
      "title": "Nowa rola",
      "nameLabel": "Nazwa roli",
      "namePlaceholder": "np. Manager dz. Content",
      "codePreview": "Kod: {{code}}",
      "codeTaken": "Ten kod jest już używany przez inną rolę",
      "groupLabel": "Grupa",
      "cancel": "Anuluj",
      "confirm": "Utwórz rolę",
      "creating": "Tworzenie..."
    },
    "confirmToggle": {
      "activateTitle": "Aktywować rolę?",
      "deactivateTitle": "Dezaktywować rolę?",
      "cancel": "Anuluj",
      "activateConfirm": "Aktywuj rolę",
      "deactivateConfirm": "Dezaktywuj rolę",
      "activateBody": "Rola „{{name}}\" zostanie ponownie aktywna. Użytkownicy przypisani do tej roli odzyskają dostęp.",
      "deactivateBody": "Dezaktywować rolę „{{name}}\"? Użytkownicy przypisani do tej roli stracą dostęp."
    }
  },
  "formats": {
    "pageTitle": "Słowniki systemowe - Formaty mediów",
    "pageSubtitle": "Zarządzanie formatami nośników reklamowych",
    "actions": {
      "addFormat": "Dodaj format",
      "edit": "Edytuj"
    },
    "filters": {
      "searchPlaceholder": "Szukaj po kodzie lub etykiecie...",
      "groupAll": "Wszystkie grupy",
      "groupSearchPlaceholder": "Szukaj grupy...",
      "groupNoResults": "Brak wyników",
      "statusAll": "Wszystkie",
      "statusActive": "Aktywne",
      "statusInactive": "Nieaktywne"
    },
    "table": {
      "code": "Kod",
      "label": "Etykieta",
      "group": "Grupa",
      "sortOrder": "Kolejność",
      "status": "Status",
      "actions": ""
    },
    "status": {
      "active": "Aktywny",
      "inactive": "Nieaktywny"
    },
    "empty": {
      "title": "Brak formatów",
      "description": "Zmień kryteria lub dodaj nowy format."
    },
    "pagination": {
      "page": "Strona {{page}} z {{total}} ({{count}} wyników)",
      "prev": "Poprzednia strona",
      "next": "Następna strona",
      "goToPage": "Strona {{page}}"
    },
    "create": {
      "title": "Dodaj format",
      "close": "Zamknij"
    },
    "edit": {
      "title": "Edytuj format",
      "close": "Zamknij"
    },
    "fields": {
      "code": "Kod",
      "codePlaceholder": "np. wf_billboard",
      "codeHint": "Unikalny identyfikator techniczny. Użyj podkreślników zamiast spacji.",
      "label": "Etykieta",
      "labelPlaceholder": "np. Wielki Format - Billboard",
      "group": "Grupa",
      "groupNone": "Brak grupy",
      "groupSearchPlaceholder": "Szukaj grupy...",
      "groupNoResults": "Brak wyników",
      "sortOrder": "Kolejność sortowania",
      "isActive": "Format aktywny"
    },
    "errors": {
      "codeTaken": "Ten kod jest już zajęty"
    },
    "groupChange": {
      "title": "Zmiana grupy formatu",
      "description": "Format {{label}} zostanie przeniesiony z grupy {{from}} do grupy {{to}}.",
      "noGroup": "Brak grupy",
      "noEffects": "Brak zmian w dostępie ról.",
      "rolesHeader": "Wpływ na dostęp ról",
      "gain": "zyskasz dostęp",
      "lose": "stracisz dostęp",
      "confirm": "Potwierdź zmianę",
      "cancel": "Anuluj"
    },
    "save": "Zapisz",
    "saving": "Zapisywanie...",
    "cancel": "Anuluj",
    "count_one": "{{count}} format",
    "count_few": "{{count}} formatów",
    "count_many": "{{count}} formatów"
  },
  "featureFlags": {
    "pageTitle": "Flagi funkcji",
    "pageSubtitle": "Włącz lub wyłącz funkcje systemowe bez dostępu do bazy danych",
    "permissionDenied": "Nie masz uprawnień do tej strony.",
    "table": {
      "key": "Klucz",
      "description": "Funkcja",
      "enabled": "Aktywna",
      "toggleLabel": "Przełącz flagę {{key}}"
    }
  }
}
